import { forwardRef, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface IconSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  /** Icon element to display on the left side */
  icon: ReactNode;
}

/**
 * Native select element with a leading icon
 * Properly centers the icon vertically and matches Input height (h-10)
 */
export const IconSelect = forwardRef<HTMLSelectElement, IconSelectProps>(
  ({ icon, className, children, ...props }, ref) => {
    return (
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
          {icon}
        </div>
        <select
          ref={ref}
          className={cn(
            'w-full h-10 pl-9 pr-3 py-2 rounded-md border border-border',
            'bg-background text-sm text-foreground',
            'focus:outline-none focus:ring-2 focus:ring-[#8FB560]',
            'disabled:opacity-70 disabled:cursor-not-allowed',
            className
          )}
          {...props}
        >
          {children}
        </select>
      </div>
    );
  }
);
IconSelect.displayName = 'IconSelect';
